import type { BlockDefinition } from '../types';
import { formSchema, type FormBlockData } from './schema';
import { FormRenderer } from './Renderer.client';

export const formBlock: BlockDefinition<FormBlockData> = {
  meta: {
    type: 'form',
    label: 'Formulario',
    description: 'Referencia a un formulario gestionado desde el admin. Se renderiza por su clave (formKey).',
    category: 'form',
    icon: 'mail',
  },
  schema: formSchema,
  defaults: {
    eyebrow: '● Contacto',
    title: 'Cuéntanos tu situación',
    subtitle: 'Lo derivamos al equipo correcto y te respondemos pronto.',
    formKey: 'contacto',
    layout: 'centered',
    variant: 'default',
    consent: 'He leído y acepto la <a href="/legal/privacidad">política de privacidad</a>.',
  },
  fields: [
    { name: 'eyebrow', label: 'Eyebrow', type: 'text', max: 80 },
    { name: 'title', label: 'Título', type: 'text', max: 200 },
    { name: 'subtitle', label: 'Subtítulo', type: 'textarea', max: 500 },
    {
      name: 'formKey',
      label: 'Formulario (key)',
      type: 'text',
      required: true,
      helperText: 'Clave del formulario gestionado en Admin → Formularios. Los campos, mensajes y validaciones vienen de ahí.',
    },
    {
      name: 'layout',
      label: 'Layout',
      type: 'select',
      options: [
        { label: 'Centrado (predeterminado)', value: 'centered' },
        { label: 'Split (texto izq, form der)', value: 'split' },
        { label: 'Inline (compacto)', value: 'inline' },
      ],
    },
    {
      name: 'variant',
      label: 'Variante visual',
      type: 'select',
      options: [
        { label: 'Por defecto', value: 'default' },
        { label: 'Card destacada', value: 'card' },
        { label: 'Fondo oscuro', value: 'dark' },
      ],
    },
    { name: 'submitLabel', label: 'Texto del botón (override)', type: 'text', max: 80, helperText: 'Si vacío, usa el del formulario en admin.' },
    { name: 'successMessage', label: 'Mensaje de éxito (override)', type: 'textarea', max: 400 },
    { name: 'consent', label: 'Texto de consentimiento (HTML)', type: 'richtext', max: 400 },
  ],
  Renderer: FormRenderer,
};

export { formSchema, FormRenderer };
export type { FormBlockData };
